var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table__body"},_vm._l((_vm.customers),function(customer){return _c('div',{staticClass:"table__row"},_vm._l((customer),function(item){return _c('div',{staticClass:"table__col"},[_vm._v(" "+_vm._s(item)+" ")])}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }